// extracted by mini-css-extract-plugin
export var backdropBlur = "_dw-0";
export var contentCard = "_dw-5";
export var frame = "_dw-2";
export var image = "_dw-4";
export var imagePane = "_dw-3";
export var modal = "_dw-1";